import { SaveButton } from 'src/admin/core'
import { useFormikContext } from 'formik'
import { AgencyForm, useUpsertAgency } from 'src/admin/scenes/entities/agencies/hooks'

export const UpdateAgency: React.FC<{ afterSave?: (promise: Promise<any>, action: string) => void }> = ({
  afterSave,
}) => {
  const { upsertAgency, loading } = useUpsertAgency()
  const form = useFormikContext()
  const { values, setSubmitting } = form
  const agency = { ...(values as AgencyForm) }
  
  const handleUpdate = () => {
    setSubmitting(true)
    const response = upsertAgency({
      variables: {
        input: {
          id: agency.id,
          name: agency.name,
          active: agency.active,

        },
      },
    })
    if (afterSave) {
      afterSave(response, 'update')
    }
    setSubmitting(false)
  }
  
  return <SaveButton onClick={handleUpdate} isLoading={loading} />
}
